import { KEEPSAKE_IMAGE } from "./keepsakeImage";

// Brand + campaign imagery. Exact approved source images, stored permanently in-repo.
const CAMPAIGN = "/campaign-assets";

export const ASSETS = {
  realCollage: `${CAMPAIGN}/real-collage.webp`,
  polaroidGrid: `${CAMPAIGN}/polaroid-grid.webp`,
  teeFront: `${CAMPAIGN}/tee-front.webp`,
  teeBack: `${CAMPAIGN}/tee-back.webp`,
  centerpiece: `${CAMPAIGN}/real-collage.webp`,
  flashProcess: KEEPSAKE_IMAGE,
  party1: `${CAMPAIGN}/party-red.webp`,
  party2: `${CAMPAIGN}/party-blue.webp`,
  curtain: `${CAMPAIGN}/real-collage.webp`,
  dancerRed: `${CAMPAIGN}/party-red.webp`,
  dancerBlue: `${CAMPAIGN}/party-blue.webp`,
  dancerGreen: `${CAMPAIGN}/dancer-green.webp`,
  dancerPurple: `${CAMPAIGN}/polaroid-grid.webp`,
  printHolder: KEEPSAKE_IMAGE,
};
